// J-215 (inbox 22 item 1): what a page shows while its guard waits on the server (the session read,
// "/"'s landing read), in place of a blank page. The wait ends within the 15-second read limit
// (`api/resilient-fetch.ts`): in the page, sign-in, or the error view with Try again.
// J-376: the router also draws it inside the signed-in shell while a page's code loads (routes are
// code-split), and the shell already has the page's one `<main>`; there it is a plain block, since two
// `main` landmarks is invalid HTML (QA deploy run 404's e2e stopped on two).
import { useContext } from "react";
import { InShellContext } from "./in-shell";

export function RoutePending() {
  const status = (
    <p className="text-muted-foreground text-sm" role="status">
      Checking your session with the server.
    </p>
  );
  if (useContext(InShellContext))
    return (
      <div className="flex flex-col justify-center py-6" data-testid="route-pending">
        {status}
      </div>
    );
  return (
    <main
      className="mx-auto flex min-h-screen max-w-[720px] flex-col justify-center p-6"
      data-testid="route-pending"
    >
      {status}
    </main>
  );
}
